import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NavBar = ({ title, subtitle }) => {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-50 bg-neutral-950/90 backdrop-blur-xl border-b border-neutral-800 px-4 py-4 flex items-center gap-3">
      <button
        data-testid="nav-back-button"
        onClick={() => navigate("/")}
        className="p-2 -ml-2 rounded-md active:bg-neutral-800 transition-colors"
        aria-label="Volver"
      >
        <ArrowLeft className="w-5 h-5 text-neutral-400" />
      </button>
      <div>
        <h1 className="text-lg font-semibold text-neutral-50 leading-none"
            style={{ fontFamily: "'Outfit', sans-serif" }}>
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs text-neutral-500 mt-0.5">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default NavBar;
